module.exports = __webpack_public_path__ + "static/media/memory.2405ab79.svg";